import React, { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import Navigations from '../../CYA/Navigations';
import { Box, Button, Container, Grid } from '@mui/material';
import { KeyboardArrowDown, WarningAmber } from '@mui/icons-material';
import Heading from '../../../Components/Heading';
import Paragraph from '../../../Components/Paragraph';
import walletpurple from '../../../../assets/walletpurple.svg';
import walletgray from '../../../../assets/walletgray.svg';
import cardgray from '../../../../assets/cardgray.svg';
import cardpurple from '../../../../assets/cardpurple.svg';
import metamask from '../../../../assets/metamask.svg';
import walletconnect from '../../../../assets/walletconnect.svg';
import coinbase from '../../../../assets/coinbase.svg';
import trust from '../../../../assets/trust.svg';
import phantom from '../../../../assets/phantom.svg';
import ledger from '../../../../assets/ledger.svg';
import ethimage from '../../../../assets/ethimage.svg';
import SVPNicon from '../../../../assets/MainIcon.png';
import usdt from '../../../../assets/usdt.png';
import usdc from '../../../../assets/usdc.png';
import web3 from '../../../../assets/web3.svg';
import important from '../../../../assets/important.png';
import PurpleButton from '../../../Components/PurpleButton';
import secure from '../../../../assets/secure.png';
import { useLocation } from 'react-router-dom';
import { useAppKit } from '@reown/appkit/react';
import { useAccount, useDisconnect } from 'wagmi';
import { CheckCircle } from '@mui/icons-material';
import { Wrapper,
WalletStatusBox,
Card2,
ConnectedWalletCard,
WalletHeader,
WalletIconWrapper,
WalletHeaderText,
WalletTitle,
WalletStatusText,
ConnectedBox,
CheckIcon,
ConnectedText,
AddressText,
DisconnectBtn,
PaymentDetailsCard,
DetailRow,
DetailLabel,
DetailValue,
ConnectedBadge,
GradientHeadingSpan,
Card,
ImportantCard,
ImportantHeader,
ImportantTitle,
ImportantList,
ImportantListItem,
TabsWrapper,
Tab,
TabLabel,
SelectWrapper,
SelectButton,
Dropdown,
Option,
ArrowIconWrapper,
Overlay,
StyledButton,
UpperBox,
WalletGrid,
WalletItem,
WalletIcon,
WalletName,
WalletIconBox,
CardFormWrapper,
FormLabel,
InputField,
FormGroup,
FormRow,
SecurePaymentBox,
SecureIcon,
SecureText,
PaymentDetailsBox,
PaymentDetailsTitle,
AmountRow,
AmountLabel,
AmountValue } from './style';
import PaymentProcessing from '../../../Components/PaymentProcessingTimer';


const PaymentHeader = () => {
    const location = useLocation();
  const [selectedTab, setSelectedTab] = useState("crypto");
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("ETH");
  const [isProcessing, setIsProcessing] = useState(false);
  // Add these states with your other useState declarations
const [cardNumber, setCardNumber] = useState('');
const [cardholderName, setCardholderName] = useState('');
const [expiryDate, setExpiryDate] = useState('');
const [cvv, setCvv] = useState('');
  const handlePayNow = () => {
  setIsProcessing(true);
};

const handlePaymentComplete = () => {
  setIsProcessing(false);
  // Add your logic here for what happens after payment processing
  // e.g., navigate to success page, show confirmation, etc.
  console.log('Payment completed!');
};
// Add formatting functions
const formatCardNumber = (value) => {
  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const matches = v.match(/\d{4,16}/g);
  const match = (matches && matches[0]) || '';
  const parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(' ');
  } else {
    return value;
  }
};

const formatExpiryDate = (value) => {
  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  if (v.length >= 2) {
    return v.slice(0, 2) + '/' + v.slice(2, 4);
  }
  return v;
};

const handleCardNumberChange = (e) => {
  const formatted = formatCardNumber(e.target.value);
  if (formatted.replace(/\s/g, '').length <= 16) {
    setCardNumber(formatted);
  }
};

const handleExpiryDateChange = (e) => {
  const formatted = formatExpiryDate(e.target.value);
  if (formatted.replace('/', '').length <= 4) {
    setExpiryDate(formatted);
  }
};

const handleCvvChange = (e) => {
  const value = e.target.value.replace(/[^0-9]/gi, '');
  if (value.length <= 3) {
    setCvv(value);
  }
};
  const selectRef = useRef(null);


 const { open } = useAppKit();
  const { address, isConnected, connector } = useAccount();
  const { disconnect } = useDisconnect();
     useEffect(() => {
    if (location.state) {
      setAuthState(location.state);
    } else {
      // Try to load from sessionStorage
      const savedPlan = sessionStorage.getItem('selectedPlan');
      const savedEmail = sessionStorage.getItem('userEmail');
      const savedGoogleUser = sessionStorage.getItem('googleUser');
      
      setAuthState({
        isWalletConnected: isConnected,
        walletAddress: address,
        googleUser: savedGoogleUser ? JSON.parse(savedGoogleUser) : null,
        email: savedEmail,
        selectedPlan: savedPlan
      });
    }
  }, [location.state, isConnected, address]);

  // Helper functions
  const getWalletName = () => {
    if (!connector) return 'Wallet';
    return connector.name || 'Connected Wallet';
  };

  const getShortAddress = (addr) => {
    if (!addr) return '';
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  const getWalletInitials = () => {
    const name = getWalletName();
    return name.slice(0, 2).toUpperCase();
  };

  const getPlanPrice = () => {
    if (authState.selectedPlan === 'yearly') return '$50.00';
    if (authState.selectedPlan === 'monthly') return '$5.00';
    return '$0.00';
  };

  const getEthAmount = () => {
    if (authState.selectedPlan === 'yearly') return '0.017';
    if (authState.selectedPlan === 'monthly') return '0.0017';
    return '0.00';
  };

  const handleWalletConnect = () => {
    open();
  };

  const handleDisconnect = () => {
    disconnect();
    setAuthState(prev => ({
      ...prev,
      isWalletConnected: false,
      walletAddress: null
    }));
  };
  const [authState, setAuthState] = useState({
    isWalletConnected: false,
    walletAddress: null,
    googleUser: null,
    email: null,
    selectedPlan: null
  });
  const options = [
    { value: "SVPN", label: "$SVPN" },
    { value: "ETH", label: "$ETH" },
    { value: "USDT", label: "$USDT" },
    { value: "USDC", label: "$USDC" }
  ];

  const wallets = [
    { name: "MetaMask", icon: metamask },
    { name: "WalletConnect", icon: walletconnect },
    { name: "Coinbase", icon: coinbase },
    { name: "Trust Wallet", icon: trust },
    { name: "Phantom", icon: phantom },
    { name: "Ledger", icon: ledger }
  ];

  const importantPoints = [
    "Make sure you have enough ETH for payment + gas fees",
    "Transaction will be confirmed on the blockchain",
    "Your subscription activates after confirmation",
    "Estimated confirmation time: 2-5 minutes"
  ];

  const handleOptionSelect = (option) => {
    setSelectedOption(option.value);
    setIsSelectOpen(false);
  };

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsSelectOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedOptionLabel = options.find(opt => opt.value === selectedOption)?.label;
// Add this helper function after your imports
const getWalletIcon = (connectorName) => {
  const walletIcons = {
    'MetaMask': metamask,
    'WalletConnect': walletconnect,
    'Coinbase Wallet': coinbase,
    'Trust Wallet': trust,
    'Phantom': phantom,
    'Ledger': ledger
  };

  const matchedKey = Object.keys(walletIcons).find(key => 
    connectorName?.toLowerCase().includes(key.toLowerCase())
  );

  return walletIcons[matchedKey] || web3;



};
const tokenIcons = {
  ETH: ethimage,
  USDT: usdt,   
  USDC: usdc,   
  SVPN: SVPNicon   
};
  return (
    <Wrapper>
      <Navigations currentStep={3} />
      <Container maxWidth="xl">
        <Grid container justifyContent="center" mb={4}>
          <Heading>
            Select payment <GradientHeadingSpan>method</GradientHeadingSpan>
          </Heading>
        </Grid>

        <Grid container justifyContent="center" mb={3}>
          <Grid item xs={12} md={7} lg={6}>
            <Card>
              <Paragraph>
                Payment Method
              </Paragraph>
              
              <TabsWrapper>
                <Tab 
                  active={selectedTab === "crypto"} 
                  onClick={() => setSelectedTab("crypto")}
                >
                  <img 
                    src={selectedTab === "crypto" ? walletpurple : walletgray} 
                    width="20" 
                    alt="crypto"
                  />
                  <TabLabel active={selectedTab === "crypto"}>Crypto</TabLabel>
                </Tab>
                <Tab 
                  active={selectedTab === "card"} 
                  onClick={() => setSelectedTab("card")}
                >
                  <img 
                    src={selectedTab === "card" ? cardpurple : cardgray} 
                    width="20" 
                    alt="card"
                  />
                  <TabLabel active={selectedTab === "card"}>Card</TabLabel>
                </Tab>
              </TabsWrapper>
              
             
                {selectedTab === "crypto" ? (
                // CRYPTO TAB - Your existing wallet connection code
                <>
                 <Paragraph style={{ color: '#D1D5DC', marginBottom: '4px', fontSize: '14px' }}>
                Select Cryptocurrency
              </Paragraph>
              <SelectWrapper ref={selectRef}>
              <SelectButton onClick={() => setIsSelectOpen(!isSelectOpen)} type="button">
                <Box display="flex" alignItems="center" gap="8px">
                  <img 
                    src={tokenIcons[selectedOption]} 
                    alt={selectedOption} 
                    style={{ width: "22px", height: "22px" }}
                  />
                  <span>{selectedOptionLabel}</span>
                </Box>

                <ArrowIconWrapper open={isSelectOpen} />
              </SelectButton>

                
                {isSelectOpen && (
                  <>
                    <Overlay onClick={() => setIsSelectOpen(false)} />
                    <Dropdown>
                      {options.map((option) => (
                      <Option
                        key={option.value}
                        selected={selectedOption === option.value}
                        onClick={() => handleOptionSelect(option)}
                      >
                        <Box display="flex" alignItems="center" gap="8px">
                          <img
                            src={tokenIcons[option.value]}
                            alt={option.value}
                            style={{ width: "22px", height: "22px" }}
                          />
                          {option.label}
                        </Box>
                      </Option>

                      ))}
                    </Dropdown>
                  </>
                )}
              </SelectWrapper>
            
                    {isConnected ? (
                    <ConnectedWalletCard>
                        <WalletHeader>
                        <WalletIconWrapper>
                            <img 
                            src={getWalletIcon(connector?.name)} 
                            alt={getWalletName()}
                            />
                        </WalletIconWrapper>
                        <WalletHeaderText>
                            <WalletTitle>Web3 Wallet</WalletTitle>
                            <WalletStatusText>Connected</WalletStatusText>
                        </WalletHeaderText>
                        </WalletHeader>
                        
                        <ConnectedBox>
                        <CheckIcon />
                        <ConnectedText>Wallet Connected</ConnectedText>
                        <AddressText>{getShortAddress(address)}</AddressText>
                        </ConnectedBox>
                        
                        <DisconnectBtn onClick={handleDisconnect}>
                        Disconnect Wallet
                        </DisconnectBtn>
                    </ConnectedWalletCard>
                    ) : (
                    <Card2>
                        <Box style={{display:'flex', gap:'8px'}}>
                        <img src={web3} alt="web3" style={{width:'100%', maxWidth:'45px', height:'auto'}} />
                        <Box>
                            <Paragraph style={{marginBottom:'0px'}}>Web3 Wallet</Paragraph>
                            <Paragraph style={{marginBottom:'0px', color:'#99A1AF', fontSize:'14px'}}>Not connected</Paragraph>
                        </Box>
                        </Box>

                        <Box style={{ width: '100%', marginTop:'20px' }}>
                        <UpperBox>
                            <StyledButton onClick={handleWalletConnect}>
                            <Box display="flex" alignItems="center" justifyContent="center" gap={1} fontWeight={'Bold'}>
                                Connect Wallet
                            </Box>
                            </StyledButton>
                        </UpperBox>
                        </Box>

                        <Paragraph style={{marginTop:'15px', color:'#99A1AF', fontSize:'13px'}}>
                        Supported Wallets:
                        </Paragraph>

                        <WalletGrid container spacing={2}>
                        {wallets.map((wallet, index) => (
                            <Grid item xs={12} sm={4} md={4} key={index}>
                            <WalletItem>
                                <WalletIcon src={wallet.icon} alt={wallet.name} />
                                <WalletName>{wallet.name}</WalletName>
                            </WalletItem>
                            </Grid>
                        ))}
                        </WalletGrid>
                    </Card2>
                    )}

                    {/* PAYMENT DETAILS - Only shown when wallet is connected */}
                    {isConnected && authState.selectedPlan && (
                    <PaymentDetailsCard>
                        <Paragraph style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px' }}>
                        Payment Details
                        </Paragraph>
                        <DetailRow>
                        <DetailLabel>Network</DetailLabel>
                        <DetailValue>Ethereum</DetailValue>
                        </DetailRow>
                        <DetailRow>
                        <DetailLabel>Token</DetailLabel>
                        <DetailValue>{selectedOptionLabel}</DetailValue>
                        </DetailRow>
                        <DetailRow>
                        <DetailLabel>Plan</DetailLabel>
                        <DetailValue>
                            {authState.selectedPlan === 'yearly' ? '1 Year' : 'Monthly'}
                        </DetailValue>
                        </DetailRow>
                        <DetailRow>
                        <DetailLabel>Amount</DetailLabel>
                        <DetailValue>{getEthAmount()} {selectedOption} (${getPlanPrice().replace('$', '')})</DetailValue>
                        </DetailRow>
                        <DetailRow>
                        <DetailLabel>Gas Fee</DetailLabel>
                        <DetailValue>~$2.50</DetailValue>
                        </DetailRow>
                    </PaymentDetailsCard>
                    )}

                    {/* PAY BUTTON - Only shown when wallet is connected */}
                    {isConnected && authState.selectedPlan && (
                    <Box style={{ width: '100%', marginTop: '24px' }}>
                        <UpperBox>
                        <StyledButton onClick={handlePayNow}>
                            Pay Now With ${selectedOption}
                        </StyledButton>
                        </UpperBox>
                    </Box>
                    )}
                <ImportantCard>
                <ImportantHeader>
                  <img src={important} alt='important' style={{width:'100%',maxWidth:'15px',height:'auto'}}/>
                  <ImportantTitle>Important</ImportantTitle>
                </ImportantHeader>
                <ImportantList>
                  {importantPoints.map((point, index) => (
                    <ImportantListItem key={index}>
                      {point}
                    </ImportantListItem>
                  ))}
                </ImportantList>
              </ImportantCard>
                </>
                ) : (
                // CARD TAB - Card payment form
                <>
                    <CardFormWrapper>
                    <FormGroup>
                        <FormLabel>Card Number</FormLabel>
                        <InputField
                        type="text"
                        placeholder="1234 5678 9012 3456"
                        value={cardNumber}
                        onChange={handleCardNumberChange}
                        maxLength="19"
                        />
                    </FormGroup>

                    <FormGroup>
                        <FormLabel>Cardholder Name</FormLabel>
                        <InputField
                        type="text"
                        placeholder="John Doe"
                        value={cardholderName}
                        onChange={(e) => setCardholderName(e.target.value)}
                        />
                    </FormGroup>

                    <FormRow>
                        <FormGroup>
                        <FormLabel>Expiry Date</FormLabel>
                        <InputField
                            type="text"
                            placeholder="MM/YY"
                            value={expiryDate}
                            onChange={handleExpiryDateChange}
                            maxLength="5"
                        />
                        </FormGroup>

                        <FormGroup>
                        <FormLabel>CVV</FormLabel>
                        <InputField
                            type="text"
                            placeholder="123"
                            value={cvv}
                            onChange={handleCvvChange}
                            maxLength="3"
                        />
                        </FormGroup>
                    </FormRow>

                    <SecurePaymentBox>
                        <Box style={{display:'flex', alignItems:'center', gap:'8px'}}>
                        <SecureIcon><img src={secure} alt='secure' style={{width:'100%',maxWidth:'20px',height:'auto'}}/> </SecureIcon>
                        <Paragraph style={{marginBottom:'0px',fontSize: '16px', color: '#51A2FF'}}>Secure Payment</Paragraph>
                        </Box>
                        <SecureText>
                        Your card details are encrypted and secure. We use industry-standard SSL encryption.
                        </SecureText>
                    </SecurePaymentBox>

                    <PaymentDetailsBox>
                        <PaymentDetailsTitle>Payment Details</PaymentDetailsTitle>
                        <AmountRow>
                        <AmountLabel>Amount</AmountLabel>
                        <AmountValue>({getPlanPrice()})</AmountValue>
                        </AmountRow>
                    </PaymentDetailsBox>

                     <Box style={{ width: '100%', marginTop: '24px' }}>
                        <UpperBox>
                        <StyledButton
                          disabled={!cardNumber || !cardholderName || !expiryDate || !cvv}
                          onClick={handlePayNow}
                        >
                          Pay Now
                        </StyledButton>
                        </UpperBox>
                    </Box>
                    </CardFormWrapper>
                </>
                )}
            </Card>
          </Grid>
        </Grid>
      </Container>
      {isProcessing && (
  <PaymentProcessing onComplete={handlePaymentComplete} />
)}
    </Wrapper>
  );
};

export default PaymentHeader;